<template>
  <section v-if="sponsors.length > 0" class="section section--carousel" >
    <div class="section__container">
      <h3>
        {{ $t('sponsors.heading') }}
      </h3>
      <div
        @mousedown="startDragging"
        @mousemove="drag"
        @mouseup="stopDragging"
        @mouseleave="stopDragging"
        @touchstart="startDragging"
        @touchmove="drag"
        @touchend="stopDragging"
        ref="carousel"
        class="flex gap-2 pt-6 overflow-auto -mx-6 px-6 md:-mx-[52px] md:px-[52px] scrollbar-hide"
      >
        <div
          v-for="sponsor in sponsors"
          class="shrink-0 w-48 h-24 rounded-xl bg-white"
        >
          <a
            :href="sponsor.link"
            target="_blank"
            class="w-48 h-24 rounded-xl overflow-hidden"
            :title="sponsor.name"
            @click="trackSponsorClick(sponsor)"
          >
            <img
              :src="sponsor.image?.formats?.thumbnail?.url"
              :alt="sponsor.name"
              class="w-48 h-24 object-cover rounded-xl"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useSponsorsStore} from "~/stores/useSponsorsStore";
import {pushToDataLayer} from "~/composables/useAnalytics";
import type SponsorLocal from "~/libs/interfaces/SponsorLocal";

const logger = useFrontendLogger()
const sponsorsStore = useSponsorsStore()
const carousel = ref<HTMLElement | null>(null)

// --- ANALYTIKA PRO SPONSOR LINK ---
const trackSponsorClick = (sponsor: SponsorLocal) => {
  pushToDataLayer({
    "event": "clickTo_content",
    "clickTo": "sponzor",
    "link": {
      "text": sponsor.name
    }
  });
}
// ----------------------------------

const pos = reactive({
  left: 0,
  x: 0
})

const startDragging = (e: MouseEvent | TouchEvent) => {
  if (!carousel.value) return

  if (e instanceof MouseEvent) {
    pos.left = carousel.value.scrollLeft
    pos.x = e.clientX
  } else {
    pos.left = carousel.value.scrollLeft
    pos.x = e.touches[0].clientX
  }
}

const drag = (e: MouseEvent | TouchEvent) => {
  if (!carousel.value) return

  let clientX: number
  if (e instanceof MouseEvent) {
    e.preventDefault()
    clientX = e.clientX
  } else {
    clientX = e.touches[0].clientX
  }

  const dx = clientX - pos.x
  carousel.value.scrollLeft = pos.left - dx
}

const stopDragging = () => {
  if (!carousel.value) return
}

const sponsors = computed(() => {
  return sponsorsStore.sponsors || []
})

const fetchSponsors = async () => {
  try {
    await sponsorsStore.fetchSponsors()
  } catch (e) {
    logger.error(e)
  }
}

await fetchSponsors()
</script>
